/**
 * Provides segmentation data based on the geolocation suing Google Maps API
 */

import q from 'q';

// get current geolocation
function getCurrentPosition() {
    var currentPositionDefer = q.defer();

    // https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/getCurrentPosition
    navigator.geolocation.getCurrentPosition(function (position) {
        currentPositionDefer.resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude
        });
    }, function (err) {
        console.error('An error occurred during Google Maps loading', err);
        currentPositionDefer.reject(err);
    });

    return currentPositionDefer.promise;
}

var provider = {
    $get: function $get(GeoCodeService) {
        return {
            /**
             * @param {String} compareBy
             * @returns {Promise}
             */
            getSegmentationData: function getSegmentationData(compareBy) {
                return getCurrentPosition().then(function (_ref) {
                    var lat = _ref.lat,
                        lng = _ref.lng;
                    return GeoCodeService.getGeoCodedAddr(lat, lng, false);
                }).then(function (locationData) {
                    return locationData[compareBy];
                }).catch(console.error);
            }
        };
    }
};

provider.$get.$inject = ['GeoCodeService'];

export default provider;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/location/GoogleMapsLocationService.js
// module id = 1071
// module chunks = 0